import { Transform, TransformFnParams } from 'class-transformer';

export function ToNumber() {
  return Transform(({ value }: TransformFnParams) => {
    if (typeof value === 'number') return value;

    if (value === null || value === undefined || value === '') return null;

    if (typeof value === 'string' && !isNaN(Number(value))) {
      return Number(value);
    }

    return value;
  });
}
